import { Component, OnInit, AfterViewInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ListItemRendererComponent } from 'gung-list';
import { EdiDispatchAdvicesActionConfigService } from '../../../services/edi-dispatch-advices-action-config/edi-dispatch-advices-action-config.service';
import { EdiService } from '../../../services/edi/edi.service';
import { EdiNavigationService } from '../../../services/edi/edi-navigation.service';

@Component({
    selector: 'lib-edi-dispatch-card-list',
    templateUrl: './edi-dispatch-card-list.component.html',
    styleUrls: ['./edi-dispatch-card-list.component.css'],
    standalone: false
})
export class EdiDispatchCardListComponent extends ListItemRendererComponent<any[]> implements OnInit, AfterViewInit {
  protected router = inject(Router);
  public ediNavigationService = inject(EdiNavigationService);

  ediNavigationBaseRoute: string;

  constructor(public actionConfigService: EdiDispatchAdvicesActionConfigService) {
    super();
  }

  ngOnInit(): void {
    this.ediNavigationBaseRoute = this.router.url.split('?')[0];
  }

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }

  trackByFn(index: any, item: any) {
    return item.id;
  }

  getIds(items: any[]): string[] {
    return items.map(i => i.id);
  }
}
